import * as React from "react";
import { useErrorLog } from "../error-provider/use-log.mjs";
const defaultContext = {
  get: (key) => {
    if (typeof process === "undefined" || process.env.NODE_ENV !== "test" && process.env.STYLEGUIDE === "false") {
      console.error("LabelProvider missing! Application must be wrapped with <LabelProvider>");
    }
    return key;
  }
};
const LabelContext = React.createContext(defaultContext);
const replaceParams = (label, params) => {
  return Object.keys(params).reduce((text, key) => text.replace("${".concat(key, "}"), params[key]), label);
};
const LabelProvider = (props) => {
  const { labels, children } = props;
  const { log } = useErrorLog();
  const get = React.useCallback(
    (key, params) => {
      const label = labels[key];
      if (!label) {
        log('Label missing for key "'.concat(key, '".'));
        return key;
      }
      if (params) {
        return replaceParams(label, params);
      }
      return label;
    },
    [labels, log]
  );
  return /* @__PURE__ */ React.createElement(LabelContext.Provider, { value: React.useMemo(() => ({ get }), [get]) }, children);
};
export {
  LabelContext,
  LabelProvider,
  defaultContext,
  replaceParams
};
